var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.marketplaces)?_c('div',[(_vm.searchMarketplace('QAS'))?_c('img',{staticStyle:{"max-width":"100px"},attrs:{"src":_vm.qasMarketplaceIcon,"height":"40","width":"55"}}):_vm._e(),(_vm.searchMarketplace('CANAM'))?_c('img',{staticStyle:{"max-width":"100px"},attrs:{"src":_vm.canamMarketplaceIcon,"height":"40","width":"55"}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }